export default __webpack_public_path__ + "static/carbon-93c9977123391b693ea764b7b8e672b1.jpg";